/*
  Custom: skip Shop Pay auto-redirect.
  Sends theme checkout buttons/links to /checkout?skip_shop_pay=true so signed-in
  Shop Pay customers land on the standard checkout (PayPal etc. visible).
  Express / dynamic checkout buttons (Shop Pay, shopify-payment-button) are not touched.
*/
(function () {
  var PARAM = 'skip_shop_pay';
  var EXPRESS =
    'shopify-payment-button, .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .cart__dynamic-checkout-buttons';
  var CHECKOUT_BUTTON = 'button[name="checkout"], input[type="submit"][name="checkout"]';

  function withParam(url) {
    if (url.indexOf(PARAM + '=') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + PARAM + '=true';
  }

  function isCheckoutUrl(href) {
    try {
      var u = new URL(href, window.location.origin);
      return u.origin === window.location.origin && /^(\/[a-z]{2}(-[a-z]{2})?)?\/checkout\/?$/i.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest || target.closest(EXPRESS)) return;

    // Cart drawer, cart page and cart notification checkout buttons (name="checkout")
    var btn = target.closest(CHECKOUT_BUTTON);
    if (btn) {
      if (btn.disabled || e.defaultPrevented) return;
      e.preventDefault();
      window.location.href = withParam('/checkout');
      return;
    }

    // Any plain link to /checkout
    var link = target.closest('a[href]');
    if (link && isCheckoutUrl(link.getAttribute('href'))) {
      link.setAttribute('href', withParam(link.getAttribute('href')));
    }
  });

  // Product page "Skip to checkout" button behaviour (snippets/product-info.liquid)
  window.skipToCheckout = function () {
    setTimeout(function () {
      window.location.href = withParam('/checkout');
    }, 300);
  };
})();
